import {GroupByGlossaryPdfPages, PdfReportTemplate, VlpProductPage, IPdfSearchResult, IPdfGroupBySearchResult, IPdfProductSearchResult, EmptyPdfPage, usePdfStore} from '@modules/pdf'
import {Fragment, pluralize, React} from '@api'

import {Font} from '@react-pdf/renderer'
import {GroupByPages, CoverPage} from './'

export const vlpReportTemplate : PdfReportTemplate= {
  label:                '',
  defaults:             {
    sections: {
      cover: false,
      specGlossary: true,
      products: true
    },
    //sections: ['specGlossary', 'products'],
    watermark: false,
    document: [{
      size:        'A4',
      pageHeight: 515,
      orientation: 'landscape'
    }],
    header: {
      showGroupBy: true
    }
  },
  renderReportTemplate: (props) => <VlpReportTemplate {...props}/>
}

export const VlpReportTemplate = ({data, download}: {data: IPdfSearchResult, download?: boolean}) => {
  const {
    catalog: {catalogItemName, groupBy: { hierarchy, isProductView }},
      itemsPerRow, rowsPerPage, config: {imageRatio, columns, sections: {cover, specGlossary, products}}, getPdfProductsFilterByGroup
    } = usePdfStore(),
    pdfProducts = getPdfProductsFilterByGroup(data)

  /*Font.register({src: '/static/fonts/MyriadPro-Regular.ttf', family: 'Myriad Pro'})
  Font.register({src: '/static/fonts/arial.ttf', family: 'Arial'})
  Font.register({src: '/static/fonts/Arial Bold.ttf', family: 'Arial Bold'})
  Font.register({src: '/static/fonts/AvenirNextLTPro-Regular.otf', family: 'Avenir Next'})*/

  return (
    <Fragment>
      {cover && <CoverPage />}

      {specGlossary && false && <GroupByGlossaryPdfPages data={(pdfProducts as IPdfProductSearchResult).items} />}

      {products && (data?.total?.value == 0 ? <EmptyPdfPage text={`No ${pluralize(catalogItemName)} Found`}/>
                    : isProductView && pdfProducts !== null ?
                    (
                       _.chunk((pdfProducts as IPdfProductSearchResult).items || [], rowsPerPage * itemsPerRow).map((pdfProducts, i) =>
                       <VlpProductPage key={i}
                        index={i}
                        products={pdfProducts}
                        download={download}
                        group={_.first(hierarchy)} />)
                    )
      : <GroupByPages data={data as IPdfGroupBySearchResult} download={download} />)}
    </Fragment>
  )
}




// WEBPACK FOOTER //
// ./src/modules/pdf/templates/vlp/VlpReportTemplate.tsx